import { render, staticRenderFns } from "./ButterflySvgDefs.vue?vue&type=template&id=e506fc64"
import script from "./ButterflySvgDefs.vue?vue&type=script&lang=js"
export * from "./ButterflySvgDefs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports